<script lang="ts" module>
  import LoginCard from '@/ui/elements/login/LoginCard.svelte';

  import type { LoginState } from '../LoginElement.svelte';

  export interface LoginGeneralProps {
    loginState: LoginState;
  }
</script>

<script lang="ts">
  let { loginState = $bindable() }: LoginGeneralProps = $props();

  function onSubmit() {
    loginState.state = loginState.mainPage ?? 'loginGeneral';
  }
</script>

<LoginCard
  showNWP={true}
  headline="Passwort zurückgesetzt"
  ctaLabel="Zurück zum Login"
  {onSubmit}
  postLink={{
    label: 'Email erneut senden',
    target: () => {
      loginState.state = 'loginResetPass';
    },
  }}
>
  {#snippet textHtml()}
    Wir haben dir einen Link an <b>{loginState.resetMail}</b> geschickt. Folge dem Link um dir ein neues
    Passwort zu setzen.
  {/snippet}
</LoginCard>
